"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _ProductDetail = _interopRequireDefault(require("@sprinx/react-com/ProductDetail"));

var _clsx = _interopRequireDefault(require("clsx"));

var _styles = require("@material-ui/core/styles");

var _useMediaQuery = _interopRequireDefault(require("@material-ui/core/useMediaQuery"));

var _useTranslate = _interopRequireDefault(require("@sprinx/react-globalize/useTranslate"));

var _Page = _interopRequireDefault(require("@sprinx/react-mui-layout/Page"));

var _GridAreaContainer = _interopRequireDefault(require("@sprinx/react-mui-components/GridAreaContainer"));

var _HomeOutlined = _interopRequireDefault(require("@material-ui/icons/HomeOutlined"));

var _NavigateNext = _interopRequireDefault(require("@material-ui/icons/NavigateNext"));

var _useCalculateProductPriceHandler = _interopRequireDefault(require("@sprinx/react-pricing/useCalculateProductPriceHandler"));

var _usePopulateProductHref = _interopRequireDefault(require("../../app/AppSettingsProvider/usePopulateProductHref"));

var _PageBreadcrumbsItem = _interopRequireDefault(require("../../components/PageBreadcrumbsItem"));

var _useShoppingCurrency = _interopRequireDefault(require("../../shop/useShoppingCurrency"));

var _LastVisitedProducts = _interopRequireDefault(require("../../components/LastVisitedProducts"));

var _PageBanner = _interopRequireDefault(require("../../components/PageBanner"));

var _useAddVisitedProduct = _interopRequireDefault(require("../../products/useAddVisitedProduct"));

var _HomePageWhy = _interopRequireDefault(require("../HomePage/components/HomePageWhy"));

var _HtmlHead = _interopRequireDefault(require("../../components/HtmlHead"));

var _StructuredDataBreadcrumbs = _interopRequireDefault(require("../../components/StructuredDataBreadcrumbs"));

var _StructuredDataProduct = _interopRequireDefault(require("../../components/StructuredDataProduct"));

var _ProductDetailImageGallery = _interopRequireDefault(require("./components/ProductDetailImageGallery"));

var _useProductShippingDateServiceCall = _interopRequireDefault(require("./components/useProductShippingDateServiceCall"));

var _useProductDeliveryOffsetsServiceCall = _interopRequireDefault(require("./components/useProductDeliveryOffsetsServiceCall"));

var _useProductPromoCodeServiceCall = _interopRequireDefault(require("./components/useProductPromoCodeServiceCall"));

var _ProductDetailAddToCartButton = _interopRequireDefault(require("./components/ProductDetailAddToCartButton"));

var _ProductDetailPrice = _interopRequireDefault(require("./components/ProductDetailPrice"));

var _ProductDetailDescription = _interopRequireDefault(require("./components/ProductDetailDescription"));

var _ProductDetailStockInfo = _interopRequireDefault(require("./components/ProductDetailStockInfo"));

var _ProductDetailInfo = _interopRequireDefault(require("./components/ProductDetailInfo"));

var _ProductDetailAdornments = _interopRequireDefault(require("./components/ProductDetailAdornments"));

var _ProductDetailDemoProductLink = _interopRequireDefault(require("./components/ProductDetailDemoProductLink"));

var _ProductDetailGifts = _interopRequireDefault(require("./components/ProductDetailGifts"));

var _ProductDetailSpagetty = _interopRequireDefault(require("./components/ProductDetailSpagetty"));

var _ProductDetailName = _interopRequireDefault(require("./components/ProductDetailName"));

var _ProductDetailCustomAside = _interopRequireDefault(require("./components/ProductDetailCustomAside"));

var _ProductDetailAdornmentsPromo = _interopRequireDefault(require("./components/ProductDetailAdornmentsPromo"));

var useStyles = (0, _styles.makeStyles)(function (theme) {
  var _productDetail, _button, _btn;

  return {
    root: {},
    title: {
      fontSize: 36,
      fontWeight: 300
    },
    productDetail: (_productDetail = {
      display: 'grid',
      gridColumnGap: theme.spacing(3),
      gridRowGap: theme.spacing(2),
      justifyItems: 'stretch',
      alignItems: 'flex-start',
      alignContent: 'flex-start',
      justifyContent: 'stretch',
      gridTemplateColumns: '1fr 1fr',
      gridTemplateRows: 'auto 30px 100px auto auto auto auto auto',
      gridTemplateAreas: "\n      'name         name             '\n      'image        info             '\n      'image        description      '\n      'image        price            '\n      'image        stockInfo        '\n      'image        customImageAside '\n      'gifts        certificates     '\n      'parameters   parameters       '\n      "
    }, (0, _defineProperty2.default)(_productDetail, theme.breakpoints.down('md'), {
      gridTemplateColumns: '1fr 1fr',
      gridColumnGap: theme.spacing(4)
    }), (0, _defineProperty2.default)(_productDetail, theme.breakpoints.down('sm'), {
      gridTemplateColumns: '0.6fr  1fr',
      gridTemplateRows: 'auto auto auto auto auto auto auto auto',
      gridTemplateAreas: "\n        \"adornments       adornments\"\n        \"name             name\"\n        \"image            image\"\n        \"price            price\"\n        \"stockInfo        stockInfo\"\n        \"addToCart        addToCart\"\n        \"description      description\"\n        \"customImageAside customImageAside\"\n        \"parameters       parameters\"\n        ",
      gridColumnGap: theme.spacing(1),
      gridRowGap: theme.spacing(1),
      alignItems: 'center'
    }), (0, _defineProperty2.default)(_productDetail, theme.breakpoints.down('xs'), {
      gridTemplateAreas: "\n          \"adornments       adornments\"\n          \"name             name\"\n          \"image            image\"\n          \"price            price\"\n          \"stockInfo        stockInfo\"\n          \"addToCart        addToCart\"\n          \"description      description\"\n          \"customImageAside customImageAside\"\n          \"parameters       parameters\"\n          \"gifts            gifts\"\n        ",
      alignItems: 'center',
      justifyItems: 'center',
      gridTemplateColumns: '0.6fr  1fr',
      gridTemplateRows: 'auto auto auto auto auto auto auto auto'
    }), _productDetail),
    page: (0, _defineProperty2.default)({}, theme.breakpoints.down('sm'), {
      width: '100%'
    }),
    addToCartButton: (0, _defineProperty2.default)({
      justifyContent: 'flex-start',
      display: 'flex'
    }, theme.breakpoints.down('sm'), {
      justifyContent: 'center'
    }),
    image: {
      height: '100%',
      width: '100%',
      maxWidth: '100%',
      maxHeight: '100%'
    },
    decoratedImage: {
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center'
    },
    activeImage: {
      height: 'auto',
      alignSelf: 'auto',
      alignItems: 'stretch',
      '& > button': {
        alignSelf: 'center'
      },
      '& img': {
        maxHeight: '100%',
        maxWidth: '100%',
        width: theme.spacing(100),
        height: theme.spacing(100)
      }
    },
    content: {
      maxHeight: '100%'
    },
    thumnails: {
      justifyContent: 'flex-start'
    },
    btn: (_btn = {
      '& button': (_button = {
        backgroundColor: theme.palette.secondary.main,
        fontSize: 20,
        fontWeight: 400
      }, (0, _defineProperty2.default)(_button, theme.breakpoints.down('md'), {
        fontSize: 18
      }), (0, _defineProperty2.default)(_button, '&:hover', {
        backgroundColor: theme.palette.secondary.main
      }), _button)
    }, (0, _defineProperty2.default)(_btn, theme.breakpoints.up('sm'), {
      '& button': {
        width: '50%',
        height: 43
      }
    }), (0, _defineProperty2.default)(_btn, theme.breakpoints.down('xs'), {
      '& button': {
        width: '100%',
        height: 45,
        maxWidth: 'none'
      }
    }), _btn),
    verticalThumbs: {
      overflow: 'hidden',
      width: '275px',
      justifyContent: 'flex-start',
      flexWrap: 'wrap',
      '&:first-of-type': {
        overflowY: 'scroll',
        overflowX: 'none',
        width: '200px',
        justifyContent: 'flex-start',
        flexWrap: 'nowrap'
      }
    },
    thumbnail: {
      boxShadow: theme.shadows[2],
      '&:not(:first-of-type)': {
        marginLeft: theme.spacing(3)
      },
      '&:last-of-type': {
        marginRight: theme.spacing(2.5)
      }
    },
    primaryImage: {
      '& > div:first-of-type': {
        minHeight: 300
      }
    }
  };
}, {
  name: 'ProductDetailPage'
});
var notAvailable = {
  available: false,
  warehouse: undefined,
  quantity: 0,
  timing: undefined
};

var _ref2 = /*#__PURE__*/_react.default.createElement(_NavigateNext.default, null);

var _ref3 = /*#__PURE__*/_react.default.createElement(_PageBanner.default, {
  position: "productTop",
  hideSkeleton: true
});

var _ref4 = /*#__PURE__*/_react.default.createElement(_LastVisitedProducts.default, null);

var _ref5 = /*#__PURE__*/_react.default.createElement(_HomePageWhy.default, null);

function ProductDetailPageLayout(_ref) {
  var pClasses = _ref.classes,
      className = _ref.className,
      pProduct = _ref.product,
      pId = _ref.productId,
      rest = (0, _objectWithoutProperties2.default)(_ref, ["classes", "className", "product", "productId"]);
  var t = (0, _useTranslate.default)();
  var classes = useStyles({
    classes: pClasses
  });
  var currency = (0, _useShoppingCurrency.default)();
  var theme = (0, _styles.useTheme)();
  var mobile = (0, _useMediaQuery.default)(theme.breakpoints.down('sm'));
  var handleAddVisitedProduct = (0, _useAddVisitedProduct.default)();
  var calculateProductPrice = (0, _useCalculateProductPriceHandler.default)(null);

  var _React$useState = _react.default.useState(undefined),
      _React$useState2 = (0, _slicedToArray2.default)(_React$useState, 2),
      shpDate = _React$useState2[0],
      setShippingDates = _React$useState2[1];

  var _React$useState3 = _react.default.useState({
    deliveryDates: [],
    available: false
  }),
      _React$useState4 = (0, _slicedToArray2.default)(_React$useState3, 2),
      delInfoState = _React$useState4[0],
      setDeliveryDate = _React$useState4[1];

  var _React$useState5 = _react.default.useState(undefined),
      _React$useState6 = (0, _slicedToArray2.default)(_React$useState5, 2),
      prices = _React$useState6[0],
      setPrices = _React$useState6[1];

  var _React$useState7 = _react.default.useState({}),
      _React$useState8 = (0, _slicedToArray2.default)(_React$useState7, 2),
      promoCode = _React$useState8[0],
      setpromoCode = _React$useState8[1];

  var getPromoCode = (0, _useProductPromoCodeServiceCall.default)();
  var populateProductHref = (0, _usePopulateProductHref.default)();

  var product = _react.default.useMemo(function () {
    return populateProductHref(pProduct);
  }, [populateProductHref, pProduct]);

  var adornments = {
    adornmentInsideTopLeft: /*#__PURE__*/_react.default.createElement(_ProductDetailAdornments.default, {
      product: product
    }),
    adornmentInsideTopRight: /*#__PURE__*/_react.default.createElement(_ProductDetailAdornmentsPromo.default, {
      product: product
    })
  };
  var priceIsRelevant = Boolean(prices && prices.price && prices.priceWithTax) && prices.price > 0 && prices.priceWithTax > 0;
  var delInfo = priceIsRelevant ? delInfoState : notAvailable;
  var available = Boolean(delInfo.warehouse); // Shipping date to be processed

  var getShippingDate = (0, _useProductShippingDateServiceCall.default)(); // Shipping date to be used for dialog if open

  var getDeliveryInfo = (0, _useProductDeliveryOffsetsServiceCall.default)();

  _react.default.useEffect(function () {
    if (window && product) {
      handleAddVisitedProduct(product);
    }
  }, [handleAddVisitedProduct, product]);

  _react.default.useEffect(function () {
    calculateProductPrice(product).then(setPrices);
  }, [calculateProductPrice, product]);

  _react.default.useEffect(function () {
    getShippingDate({
      id: product.id
    }).then(function (res) {
      return setShippingDates(res);
    });
  }, [getShippingDate, product.id]);

  _react.default.useEffect(function () {
    getDeliveryInfo({
      id: product.id
    }).then(function (x) {
      return setDeliveryDate(x);
    });
  }, [getDeliveryInfo, product.id]);

  _react.default.useEffect(function () {
    getPromoCode({
      taxonomies: product.taxonomies
    }).then(function (x) {
      return setpromoCode(x);
    });
  }, [getPromoCode, product.taxonomies]);

  return /*#__PURE__*/_react.default.createElement(_Page.default, (0, _extends2.default)({}, rest, {
    classes: {
      content: classes.page
    },
    className: (0, _clsx.default)(classes.root, className),
    title: t(product.name, {
      acceptString: true
    }),
    disableHelmet: true,
    BreadcrumbsProps: {
      separator: _ref2,
      disableHistory: true,
      disableHome: true
    },
    breadcrumbItems: /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement(_PageBreadcrumbsItem.default, {
      Icon: _HomeOutlined.default,
      label: t('globalNavigation/home'),
      to: '/'
    }), product.breadcrumbs.map(function (b, idx) {
      return /*#__PURE__*/_react.default.createElement(_PageBreadcrumbsItem.default, {
        key: idx.toString(),
        label: t(b.label, {
          acceptString: true
        }),
        to: b.href
      });
    }), /*#__PURE__*/_react.default.createElement(_PageBreadcrumbsItem.default, {
      label: t(product.name),
      to: product.href
    }))
  }), product.htmlHead && /*#__PURE__*/_react.default.createElement(_HtmlHead.default, {
    htmlHead: product.htmlHead
  }), /*#__PURE__*/_react.default.createElement(_StructuredDataBreadcrumbs.default, {
    breadcrumbs: product.breadcrumbs
  }), /*#__PURE__*/_react.default.createElement(_StructuredDataProduct.default, {
    product: product
  }), _ref3, /*#__PURE__*/_react.default.createElement(_ProductDetail.default, {
    className: classes.productDetail
  }, /*#__PURE__*/_react.default.createElement(_ProductDetailName.default, {
    product: product,
    variant: "page",
    classes: {
      content: classes.title
    },
    component: "h1"
  }), !mobile && /*#__PURE__*/_react.default.createElement(_ProductDetailInfo.default, {
    product: product
  }), /*#__PURE__*/_react.default.createElement(_ProductDetailImageGallery.default, {
    product: product,
    adornments: !mobile && available ? adornments : undefined,
    ProductImageGalleryProps: {
      openModalOnThumbnailClick: true,
      PrimaryImageProps: {
        ProductImageProps: {
          mediaSizeMap: {
            mini: 'mini',
            small: 'small',
            normal: 'medium',
            big: 'medium'
          },
          shape: 'square'
        }
      },
      ImageGalleryThumbnailsProps: {
        classes: {
          thumbnail: classes.thumbnail
        }
      },
      ProductImageModalProps: {
        classes: {
          activeImage: classes.activeImage,
          content: classes.content
        },
        ProductImageThumnailsProps: {
          size: 'normal',
          classes: {
            root: classes.thumnails,
            vertical: classes.verticalThumbs
          }
        },
        ProductImageDecoratedProps: {
          shape: 'square',
          classes: {
            image: classes.decoratedImage
          },
          ProductImageProps: {
            classes: {
              root: classes.image,
              image: classes.image
            },
            mediaSizeMap: {
              mini: 'mini',
              small: 'small',
              normal: 'medium',
              big: 'original'
            }
          }
        }
      }
    },
    ProductImageGalleryNarrowProps: {
      JumbotronProps: {
        className: classes.primaryImage
      }
    }
  }), mobile && available && /*#__PURE__*/_react.default.createElement(_ProductDetailAdornments.default, {
    product: product
  }), /*#__PURE__*/_react.default.createElement(_ProductDetailStockInfo.default, {
    product: product,
    delInfo: delInfo,
    available: available,
    shipping: shpDate
  }), /*#__PURE__*/_react.default.createElement(_ProductDetailDescription.default, {
    product: product,
    mobile: mobile
  }), Boolean(prices) && /*#__PURE__*/_react.default.createElement(_ProductDetailPrice.default, {
    priceIsRelevant: priceIsRelevant,
    prices: prices,
    product: product,
    currency: currency,
    shipping: shpDate,
    available: available,
    showButton: Boolean(delInfo.id),
    promoCode: promoCode
  }), !mobile && /*#__PURE__*/_react.default.createElement(_GridAreaContainer.default, {
    renderToGridArea: 'gifts'
  }, /*#__PURE__*/_react.default.createElement(_ProductDetailDemoProductLink.default, {
    product: product
  }), !mobile && /*#__PURE__*/_react.default.createElement(_ProductDetailGifts.default, {
    product: product
  })), /*#__PURE__*/_react.default.createElement(_ProductDetailCustomAside.default, {
    product: product,
    mobile: mobile
  }), mobile && /*#__PURE__*/_react.default.createElement(_ProductDetailAddToCartButton.default, {
    available: available,
    product: product
  }), /*#__PURE__*/_react.default.createElement(_ProductDetailSpagetty.default, {
    product: product
  })), _ref4, _ref5);
}

process.env.NODE_ENV !== "production" ? ProductDetailPageLayout.propTypes = {
  classes: _propTypes.default.shape({
    activeImage: _propTypes.default.string,
    addToCartButton: _propTypes.default.string,
    btn: _propTypes.default.string,
    content: _propTypes.default.string,
    decoratedImage: _propTypes.default.string,
    image: _propTypes.default.string,
    page: _propTypes.default.string,
    primaryImage: _propTypes.default.string,
    productDetail: _propTypes.default.string,
    root: _propTypes.default.string,
    thumbnail: _propTypes.default.string,
    thumnails: _propTypes.default.string,
    title: _propTypes.default.string,
    verticalThumbs: _propTypes.default.string
  }),
  className: _propTypes.default.string,
  product: _propTypes.default.shape({
    breadcrumbs: _propTypes.default.arrayOf(_propTypes.default.shape({
      href: _propTypes.default.string,
      label: _propTypes.default.string
    })),
    description: _propTypes.default.arrayOf(_propTypes.default.shape({
      language: _propTypes.default.string,
      text: _propTypes.default.string
    })),
    href: _propTypes.default.string,
    htmlHead: _propTypes.default.shape({
      meta: _propTypes.default.arrayOf(_propTypes.default.shape({
        content: _propTypes.default.string,
        name: _propTypes.default.string.isRequired
      })),
      title: _propTypes.default.string
    }),
    id: _propTypes.default.string.isRequired,
    name: _propTypes.default.arrayOf(_propTypes.default.shape({
      language: _propTypes.default.string.isRequired,
      text: _propTypes.default.string
    })),
    stockQuantity: _propTypes.default.shape({
      available: _propTypes.default.bool
    }),
    taxonomies: _propTypes.default.array
  }),
  productId: _propTypes.default.string
} : void 0;
ProductDetailPageLayout.defaultProps = {
  classes: undefined,
  className: undefined,
  product: undefined,
  productId: undefined
};
var _default = ProductDetailPageLayout;
exports.default = _default;